/* eslint-disable */
export default {
  ringing: '着信通話',
  callConnected: '通話を接続済み',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
